import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { areaResultTranslations } from '../../../translations/areaResult';

export enum SummaryType {
  SUM = 'sum',
  GROSSAVG = 'grossAvg',
}

type AreaResultHeaderTooltipProps = {
  headerText: string;
  tooltipText: string;
  summaryType: SummaryType;
  isBold?: boolean;
};

export const AreaResultHeaderTooltip: FC<AreaResultHeaderTooltipProps> = ({
  headerText,
  tooltipText,
  summaryType,
  isBold = false,
}) => {
  const { t } = useTranslation();
  const { summaryTypeText } = areaResultTranslations;
  return (
    <Tooltip
      text={
        <ColumnFlexContainer gap={[2]}>
          <Typography type="button" color="white">
            {tooltipText}
          </Typography>
          <RowFlexContainer alignItems="center">
            <Typography color="white">
              {t(areaResultTranslations.summary.key, areaResultTranslations.summary.defaultValue)}:{' '}
            </Typography>
            <Typography padding={[1]} color="white">
              {t(summaryTypeText[summaryType].key, summaryTypeText[summaryType].defaultValue)}
            </Typography>
          </RowFlexContainer>
        </ColumnFlexContainer>
      }
      position="bottom"
    >
      <div>
        <Typography type={isBold ? 'button' : 'body2'}>{headerText}</Typography>
      </div>
    </Tooltip>
  );
};
